import { ErrorBoundary, Provider } from '@rollbar/react';
import * as React from 'react';
import { ThemeProvider } from 'styled-components';

import { GlobalStyleWrap } from './Components/GlobalStyle';
import { theme } from './Components/GlobalStyle/theme';
import Page from './Components/Page';
import ErrorSplash from './Components/Splashes/Error';
import Spinner from './Components/Splashes/Spinner';

const rollbarConfig = {
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  environment: import.meta.env.MODE || 'development',
  captureUncaught: true,
  captureUnhandledRejections: true
};

if (!import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN) {
  console.error('missing access token');
}

const App = () => (
  <Provider config={rollbarConfig}>
    <ThemeProvider theme={theme}>
      <GlobalStyleWrap {...theme} />
      <ErrorBoundary fallbackUI={ErrorSplash}>
        <React.Suspense fallback={<Spinner />}>
          <Page />
        </React.Suspense>
      </ErrorBoundary>
    </ThemeProvider>
  </Provider>
);

export default App;
